<template>
  <div>
    <div :class="s.wrap">
      <div :class="s.chat" v-for="(message, i) in messages" :key="i">
        <li
          :class="message.fromUser.id === user.id ? s.q : s.a">
          <div :class="message.fromUser.id === user.id ? s.question : s.answer">
            <div :class="s.name">{{ message.fromUser.username }} [{{ formatTimestamp(message.created_at, 'YYYY/MM/DD HH:mm') }}]</div>
            <spacer :y="1"/>
            <div>
              <p :class="s.message" v-html="message.message"></p>
            </div>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  Spacer,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'chat-history',
  props: ['data'],
  mixins: [cf],
  components: {
    Spacer,
  },
  data() {
    return {
      messages: [],
    };
  },
  created() {
    this.getMessages();
  },
  computed: {
    ...mapState(['helper', 'user']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getMessages() {
      const params = {
        flags: [1],
        reservationId: this.data.reservation_id,
      };
      this.axios({
        method: 'GET',
        url: '/v1/message/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.messages = res.messages.data;
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        });
    },

  },
};
</script>
<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
}
.buttons {
  height: 100%;
  text-align: center;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    margin: 8px 4px 0;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.mt_0 {
      margin-top: 0;
    }
    &.blue {
      background-color: var(--primary-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}
.chat {
  margin-bottom: 24px;
  &:not(:first-child) >li {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: -24px;
      left: 30px;
      width: 3px;
      height: 24px;
    }

    &.q {
      &::before {
        background-color: #25db2e;
      }
    }
    &.a {
      &::before {
        background-color: #26aac7;
      }
    }
  }
  .name {
    font-size: 16px;
  }
}

.question, .answer {
  padding: 15px;
  border-radius: 8px;
}

.question {
  background-color: #e2f5df;
}
.answer {
  background-color: #daeef2;
}
.message {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
